export function XML_Cmd4(theCmd, param1, param2, param3, param4, xmlCanvas) {
  var s = xmlCanvas.GetStream();
  xmlCanvas.OutputElementQuin("cm", theCmd, param1, param2, param3, param4, s);
}
